'use strict';

import {dropzoneExists} from "../jquery-functions-library";
import {element_exists} from "../functions";
import * as toastr from "toastr";

export var fnHolidayPayObligationsUpload = function () {
    const tableName = '#datatable-holiday-pay-obligations';

    if (!element_exists(tableName)) return false;

    const btnName = '.btn-upload-holiday-obligation';
    const $table = $(tableName);
    const $form = $('#form-upload-holiday-pay-obligation');
    const $modal = $('#modal-upload-holiday-pay-obligation');
    const $container = $('.container-upload-holiday-pay-obligation');

    $modal.on('hidden.bs.modal', function () {
        $container.html('');
    });

    $(document).off('click', btnName).on('click', btnName, function (e) {
        $modal.modal('show');

        const url = $(this).data('href');
        const dropzoneId = 'dropzone-upload-holiday-pay-obligation';
        const dropzoneSelector = '#dropzone-upload-holiday-pay-obligation';

        $container.html(`<div class="dropzone" id="${dropzoneId}">`);

        if (!dropzoneExists(dropzoneSelector)) {
            const $dropzone = $(dropzoneSelector);

            console.log($dropzone);
            Dropzone.autoDiscover = false;
            const lang = allLangFiles.dropzone;

            $dropzone.dropzone({
                acceptedFiles: '.xls,.xlsx',
                dictDefaultMessage: lang.dictDefaultMessage,
                dictFallbackMessage: lang.dictFallbackMessage,
                dictFallbackText: lang.dictFallbackText,
                dictFileTooBig: lang.dictFileTooBig,
                dictInvalidFileType: lang.dictInvalidFileType,
                dictResponseError: lang.dictResponseError,
                dictCancelUpload: lang.dictCancelUpload,
                dictCancelUploadConfirmation: lang.dictCancelUploadConfirmation,
                dictRemoveFile: lang.dictRemoveFile,
                dictMaxFilesExceeded: lang.dictMaxFilesExceeded,

                url: url,
                parallelUploads: 1,
                addRemoveLinks: true,
                maxFiles: 1,
                sending: function (file, xhr, formData) {
                    formData.append("_token", $('[name="_token"]').val());
                },
                success: function (file, response) {

                    if (response.missing_employees_text !== '') {
                        toastr.warning(`${response.success}<br>${response.missing_employees_text}`);
                    } else {
                        toastr.success(response.success);
                    }

                    $table.DataTable().ajax.reload(null, false);
                    return file.previewElement.classList.add("dz-success");
                },
                init: function () {

                    const myDropzone = this;

                    this.on('error', function (file, errorMessage) {

                        let errors = '';
                        for (const datos in errorMessage.errors) {
                            errors += errorMessage.errors[datos] + '<br>';
                        }
                        if (errorMessage.status == 403) {
                            toastr.error(allLangFiles.forms.unauthorized);
                        }
                        if (errors != '') {
                            toastr.error(errors);
                        }
                        file.previewElement.classList.add("dz-complete");
                        this.emit('error', file, allLangFiles.forms.general.error);
                    });

                    this.on('maxfilesreached', function () {
                        myDropzone.removeEventListeners();
                    });

                    this.on("removedfile", function (file) {
                        myDropzone.setupEventListeners();
                        myDropzone.options.maxFiles = 1;
                    });
                },
            });
        }

    });
};